module.exports = __webpack_public_path__ + "img/92cff8d.png";